import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

const KPICard = ({ title, value, subtitle }) => (
  <Col md={4} lg className="mb-3">
    <Card className="h-100">
      <CardBody className="text-center">
        <h6 className="text-muted mb-1">{title}</h6>
        <h3 className="mb-0">{value}</h3>
        {subtitle && <small className="text-muted">{subtitle}</small>}
      </CardBody>
    </Card>
  </Col>
);

const SalesOverviewCards = ({ overview }) => {
  if (!overview) return null;

  return (
    <Row>
      <KPICard title="Total Leads" value={overview.totalLeads} />
      <KPICard title="Leads Completados" value={overview.completedLeads} />
      <KPICard title="Ingresos Totales" value={`$${overview.totalRevenue}`} />
      <KPICard title="Ticket Promedio" value={`$${overview.averageTicket}`} />
      <KPICard
        title="Tasa de Conversión"
        value={`${overview.conversionRate}%`}
      />
    </Row>
  );
};

export default SalesOverviewCards;
